import { ComboboxInput as BaseComboboxInput } from '@reach/combobox'
import * as React from 'react'

import { styled } from '~/styled'

export const StyledComboboxInput = styled(BaseComboboxInput, {
  base: [
    'bg-(image:--bg-chevron)',
    'bg-position-[right_--spacing(3)_top_50%,0_0]',
    '[background-repeat:no-repeat,repeat-x]',
    'bg-size-[--spacing(5)_auto,100%]',
    'shadow-none',
    'appearance-none',
    'rounded-md',
    'box-border',
    'text-grey-1000',
    'cursor-text',
    'block',
    'font-body',
    'h-10',
    'pl-3',
    'pr-10',
    'transition-all',
    'duration-100',
    'ease-out',
    'w-full',
    'placeholder:opacity-100',
    'placeholder:text-grey-700',
    'disabled:bg-grey-200',
    'disabled:cursor-not-allowed',
    'disabled:text-grey-800'
  ],

  variants: {
    size: {
      sm: ['h-8', 'text-sm', 'leading-[1.7]'],
      md: ['h-10', 'text-md', 'leading-loose'],
      lg: ['h-12', 'text-md', 'leading-loose']
    },
    appearance: {
      standard: [
        'bg-white',
        'border',
        'border-grey-700',
        'focus-within:border-primary-800',
        'focus-within:outline-none'
      ],
      modern: [
        'bg-grey-100',
        'border-none',
        'focus-within:outline-2',
        'focus-within:outline-blue-800',
        'focus-within:outline-offset-1',
        'focus-within:outline-solid',
        'focus-within:z-1'
      ]
    },
    theme: {
      white: [],
      grey: []
    },
    state: {
      error: []
    }
  },
  compoundVariants: [
    {
      state: 'error',
      appearance: 'standard',
      class: ['border', 'border-danger']
    },
    {
      state: 'error',
      appearance: 'modern',
      class: ['bg-danger-light', 'focus-within:outline-danger']
    },
    {
      appearance: 'modern',
      theme: 'white',
      class: ['bg-white']
    },
    {
      appearance: 'modern',
      theme: 'grey',
      class: ['bg-grey-100']
    }
  ]
})

export type ComboboxInputProps = React.ComponentProps<
  typeof StyledComboboxInput
>

export const ComboboxInput = React.forwardRef<
  HTMLInputElement,
  ComboboxInputProps
>(({ size = 'md', appearance = 'standard', ...rest }, ref) => (
  <StyledComboboxInput
    size={size}
    appearance={appearance}
    {...rest}
    ref={ref}
  />
))
